export default function HowItWorksSection() {
  const steps = [
    {
      number: '1',
      title: 'Choisissez votre établissement',
      description: 'Parcourez nos restaurants et boutiques locales sur Localygo. Explorez les menus, lisez les avis et trouvez exactement ce dont vous avez envie.',
      icon: 'ri-restaurant-line'
    },
    {
      number: '2',
      title: 'Passez votre commande',
      description: 'Sélectionnez vos articles préférés, personnalisez votre commande selon vos préférences et validez votre panier en toute simplicité.',
      icon: 'ri-shopping-cart-line'
    },
    {
      number: '3',
      title: 'Suivez la livraison',
      description: 'Un livreur local prend en charge votre commande. Suivez en temps réel sa progression jusqu\'à votre porte pour une transparence totale.',
      icon: 'ri-map-pin-user-line'
    },
    {
      number: '4',
      title: 'Savourez !',
      description: 'Recevez votre commande rapidement et profitez de vos produits frais et délicieux livrés par un habitant de votre quartier.',
      icon: 'ri-emotion-happy-line'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Comment ça marche ?
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Quatre étapes simples pour recevoir vos commandes à domicile
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="text-center">
                <div className="relative inline-block mb-6">
                  <div className="w-20 h-20 flex items-center justify-center bg-gradient-to-br from-teal-500 to-teal-600 rounded-full shadow-lg">
                    <i className={`${step.icon} text-3xl text-white`}></i>
                  </div>
                  <div className="absolute -top-2 -right-2 w-10 h-10 flex items-center justify-center bg-gray-900 text-white rounded-full text-lg font-bold">
                    {step.number}
                  </div>
                </div>
                
                <h3 className="text-xl font-semibold text-gray-900 mb-3">
                  {step.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  {step.description}
                </p>
              </div>

              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-10 left-full w-full h-0.5 bg-gradient-to-r from-teal-600 to-teal-300 -translate-x-1/2">
                  <i className="ri-arrow-right-line text-teal-600 absolute right-0 top-1/2 -translate-y-1/2 text-2xl"></i>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
